import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import './Style.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEnvelope, faLock, faEye, faEyeSlash, faChevronLeft, faUserAlt, faTimes, faCheck } from '@fortawesome/free-solid-svg-icons'
import { faGooglePlusG, faFacebookF } from '@fortawesome/free-brands-svg-icons';
import { googleProvider, fbProvider } from '../../firebase-config';
import { toast } from 'react-toastify';
import { useDispatch, useSelector } from 'react-redux'
import { makeLoginExternal, makeRegisterFirebase } from '../../core/actions/authActions'
import Text from '../../components/native/Text'


export const RegisterPage: React.FunctionComponent = () => {

    const { btnPrimaryColor } = useSelector((store: any) => (store.ui));

    const dispatch = useDispatch();

    const mailIcon = <FontAwesomeIcon icon={faEnvelope} color={btnPrimaryColor} />
    const userIcon = <FontAwesomeIcon icon={faUserAlt} color={btnPrimaryColor} />
    const secureIcon = <FontAwesomeIcon icon={faLock} color={btnPrimaryColor} />
    const eyeIcon = <FontAwesomeIcon icon={faEye} color={btnPrimaryColor} />
    const eyeCloseIcon = <FontAwesomeIcon icon={faEyeSlash} color={btnPrimaryColor} />
    const googleIcon = <FontAwesomeIcon icon={faGooglePlusG} color='#ffffff' />
    const fbIcon = <FontAwesomeIcon icon={faFacebookF} color='#ffffff' />
    const back = <FontAwesomeIcon icon={faChevronLeft} color='#000000' />;
    const checkIcon = <FontAwesomeIcon icon={faCheck} color={btnPrimaryColor} />;
    const errorIcon = <FontAwesomeIcon icon={faTimes} color={btnPrimaryColor} />;

    const [registerName, setRegisterName] = useState("");
    const [registerEmail, setRegisterEmail] = useState("");
    const [registerPassword, setRegisterPassword] = useState("");

    const [validatePwd, setValidatePwd] = useState({
        uppercase: false,
        number: false,
        minlen: false,
        nochars: false
    });

    const [showPwd, setShowPwd] = useState<any>({ type: 'password', icon: eyeCloseIcon });

    const togglePwd = () => {
        if (showPwd.type === 'password') {
            setShowPwd({ type: 'text', icon: eyeIcon });
        } else {
            setShowPwd({ type: 'password', icon: eyeCloseIcon });
        }
    }

    const isUpper = (str) => {
        return /[A-Z]/.test(str);
    }

    const register = async () => {

        if (Object.values(validatePwd).indexOf(false) > -1) {

            toast.warning('La contraseña no cumple con los requerimientos', {
                position: "bottom-right",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });

            return;
        }

        dispatch(makeRegisterFirebase({
            registerEmail,
            registerPassword,
            registerName
        }));

        /* successToast('Registro exitoso!');
        setTimeout(() => {
            navigate('/');
        }, 1000); */
    };

    const externalRegister = async (provider) => {
        dispatch(makeLoginExternal(provider));
    }

    const handleKeyUp = () => {

        setValidatePwd({
            uppercase: isUpper(registerPassword),
            number: /[0-9]/.test(registerPassword),
            minlen: registerPassword.length >= 8,
            // eslint-disable-next-line
            nochars: !(/[ `!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/.test(registerPassword))
        });
    }

    return (
        <div className='flex flex-col justify-between items-center h-full absolute w-full pt-8 pb-8'>

            <div className='fixed left-3 top-3'>
                <Link to="/auth"> <strong> {back}  </strong></Link>
            </div>

            <div className='w-full max-w-md p-8'>
                <div className='title_lg'>Crear una cuenta</div> <br />
                <div className='subtitle-lg'>Ya tienes una cuenta?, <span><Link to="/auth/login"><Text color={btnPrimaryColor} size={16}>Inicia Sesión</Text></Link></span></div>
            </div>
            <div className='w-full p-8 max-w-md'>

                <div className='w-full'>
                    <div className="flex items-center border-b py-2" style={{borderColor:btnPrimaryColor}}>
                        {userIcon}
                        <input className="appearance-none bg-transparent border-none w-full text-gray-700 mr-3 py-1 px-2 leading-tight focus:outline-none" type="text" placeholder="Nombre" aria-label="Name"
                            onChange={(event) => {
                                setRegisterName(event.target.value);
                            }} />
                    </div>
                </div>

                <div className='w-full mt-4'>
                    <div className="flex items-center border-b py-2" style={{borderColor:btnPrimaryColor}}>
                        {mailIcon}
                        <input className="appearance-none bg-transparent border-none w-full text-gray-700 mr-3 py-1 px-2 leading-tight focus:outline-none"
                            type="email" placeholder="Correo electrónico" aria-label="Email" onChange={(event) => {
                                setRegisterEmail(event.target.value);
                            }} />
                    </div>
                </div>

                <div className='w-full mt-4'>
                    <div className="flex items-center border-b py-2" style={{borderColor:btnPrimaryColor}}>
                        {secureIcon}
                        <input className="appearance-none bg-transparent border-none w-full text-gray-700 mr-3 py-1 px-2 leading-tight focus:outline-none"
                            type={showPwd.type} placeholder="Contraseña" aria-label="Password" onChange={(event) => {
                                setRegisterPassword(event.target.value);
                            }} onKeyUp={handleKeyUp} />
                        <button onClick={togglePwd} type='button'>{showPwd.icon}</button>
                    </div>
                </div>

                <div className="grid grid-cols-2 gap-2 mt-4">
                    <div>{validatePwd.uppercase ? checkIcon : errorIcon} <span className='micro-text'>Una letra mayúscula</span></div>
                    <div>{validatePwd.minlen ? checkIcon : errorIcon} <span className='micro-text'>Mínumo 8 caracteres</span></div>
                    <div>{validatePwd.number ? checkIcon : errorIcon} <span className='micro-text'>Un número</span></div>
                    <div>{validatePwd.nochars ? checkIcon : errorIcon} <span className='micro-text'>No caracteres especiales</span></div>
                </div>

            </div>
            <div className='flex flex-col w-full p-8 max-w-md'>
                <button className="primary_btn hover:primary_btn text-white font-bold py-2 px-4 w-full" onClick={register}>
                    Registrarse
                </button>
                <div className='mt-4 flex flex-row justify-center items-center'>
                    <span className='mr-4'>o continúa con</span>
                    <div className='circle-icon mr-4' onClick={() => { externalRegister(fbProvider) }}>{fbIcon}</div>
                    <div className='circle-icon' onClick={() => { externalRegister(googleProvider) }}>{googleIcon}</div>
                </div>
            </div>
        </div>
    )
}
